import $dataStr from 'fxdom/es/dataStr.js';
import { html, View } from 'rune-ts';
import { PlusShopTypeS } from '../../../../features/PlusShop/outbound/share';
import { ProductThumbnailOption } from '../../../../features/ProductList/type';
import { makeEmptyScreenNavigate, makeSubScreenNavigate } from '../../../../shared/app/navigate';
import { typo } from '../../../../shared/typography/typo';
import { dataStr } from '../../../../shared/util/dataStr';
import { makeDefaultProfileImg } from '../../../../shared/util/helper';
import { makePlusUrl } from '../../../../shared/util/url';
import { LegacyProductThumbnail } from '../ProductThumbnail/LegacyProductThumbnail.ts';
import klass from './PlusShopCard.module.scss';
import { AdultVerificationThumbnail } from '../ProductThumbnail/AdultVerificationThumbnail';
import { getResizedUrl } from '../../../../shared/util/image';

interface PlusShopCardOption {
  klass?: string;
  adult_check_needed?: boolean;
}

export class PlusShopCard extends View<PlusShopTypeS.PlusShopCardType> {
  state: PlusShopCardOption & {
    // FIXME
  };

  constructor(data: PlusShopTypeS.PlusShopCardType, option: PlusShopCardOption = {}) {
    super(data);

    this.state = {
      klass: option.klass,
      adult_check_needed: option.adult_check_needed,
    };
  }

  protected override template() {
    const { domain_name, name, is_adult, mall_logo_url, target, products } = this.data;

    return html`
      <div class="${klass.PlusShopCard}">
        <div class="${klass.wrap}">
          <div class="${klass.thumb}">
            <a
              data-post-message="${dataStr(makeEmptyScreenNavigate(makePlusUrl(domain_name, `/${ET.lang}`)))}"
              href="${makePlusUrl(domain_name, `/${ET.lang}`)}"
              target="${target}"
            >
              <img
                src="${mall_logo_url
                  ? getResizedUrl({
                      url: mall_logo_url,
                      width: 174 * 2,
                      format: 'webp',
                      quality: 70,
                    })
                  : makeDefaultProfileImg(174 * 2)}"
                alt="${html.preventEscape(name)}"
                class="${klass.thumb_img}"
              />
            </a>
          </div>
          <div class="${klass.txt_info}">
            <div class="${klass.name} ${typo('20_bold')}">
              <a
                data-post-message="${dataStr(
                  makeEmptyScreenNavigate(makePlusUrl(domain_name, `/${ET.lang}`)),
                )}"
                href="${makePlusUrl(domain_name, `/${ET.lang}`)}"
                target="${target}"
              >
                ${html.preventEscape(name)}
              </a>
            </div>
            <div class="${klass.seller_type} ${typo('14_medium')}">&nbsp;</div>
          </div>

          <div class="${klass.products}">
            ${products.map((product) => {
              const option: ProductThumbnailOption = { resize_width: 300, img_alt: product.name || '' };
              return html`
                <div class="${klass.product_thumb}">
                  <a
                    href="/${ET.lang}/${product.store_domain_name}/products/${product.id}"
                    target="${product.target}"
                    data-post-message="${$dataStr(
                      makeSubScreenNavigate(
                        makePlusUrl(
                          domain_name,
                          `/${ET.lang}/${product.store_domain_name}/products/${product.id}`,
                        ),
                      ),
                    )}"
                  >
                    ${is_adult && this.state.adult_check_needed
                      ? new AdultVerificationThumbnail()
                      : new LegacyProductThumbnail(product, option)}
                  </a>
                </div>
              `;
            })}
          </div>
        </div>
      </div>
    `;
  }
}
